module.exports = __webpack_public_path__ + "static/media/24UHCHR12.f6a3c7e2.jpg";